import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, DollarSign, BarChart3, MessageCircle, FileText, Sparkles, TrendingUp } from "lucide-react";

const Stat = ({ icon: Icon, label, value, sub, accent }) => (
  <div className="kr-card p-6">
    <div className="flex items-start justify-between">
      <div className="kr-overline">{label}</div>
      <Icon className="h-4 w-4" style={{ color: accent }} strokeWidth={1.5} />
    </div>
    <div className="font-display text-4xl mt-3 leading-none" style={{ color: accent }}>{value}</div>
    {sub && <div className="text-xs text-white/40 mt-2 font-mono">{sub}</div>}
  </div>
);

export default function AdminOverview() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/overview").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const d = data || {};
  return (
    <div className="p-8 max-w-[1600px] mx-auto">
      <div className="kr-overline text-[#8A52FF]">[ ADMIN OVERVIEW ]</div>
      <h1 className="font-display text-4xl mt-2 tracking-tight" data-testid="admin-overview-title">Mission Control</h1>
      <p className="text-white/55 text-sm mt-1.5">High-level health of the entire AlphaCore platform.</p>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Users} label="Total Users" value={d.users_total ?? "—"} sub={`+${d.new_users_7d ?? 0} new in 7d`} accent="#00E5FF" />
        <Stat icon={TrendingUp} label="Paid Users" value={d.users_paid ?? "—"} sub="Starter / Pro / Ent" accent="#34D399" />
        <Stat icon={Sparkles} label="Generations" value={d.generations_total ?? "—"} sub="all-time" accent="#8A52FF" />
        <Stat icon={FileText} label="Files Stored" value={d.files_total ?? "—"} accent="#00E5FF" />
      </div>
      <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Stat icon={DollarSign} label="Revenue (all-time)" value={`$${(d.revenue_total || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} sub={`${d.revenue_count || 0} paid txns`} accent="#34D399" />
        <Stat icon={MessageCircle} label="Open Tickets" value={d.tickets_open ?? "—"} sub="needs attention" accent="#FBBF24" />
      </div>
    </div>
  );
}
